/**
 * ARAM Auth Layout entry — version switch.
 * Default: 1.2 (video hiperrealista verticales, cierre 2026–2027).
 * Archive: 1.1. Override with VITE_AUTH_UI_VERSION=1.1
 */
import { AUTH_UI_VERSION } from '@/layouts/auth/authUiVersion'
import { AuthLayoutV11 } from '@/layouts/auth/AuthLayout.v1.1'
import { AuthLayoutV12 } from '@/layouts/auth/AuthLayout.v1.2'
export { AuthEffectCtx } from '@/layouts/auth/AuthEffectCtx'

export function AuthLayout() {
  if (AUTH_UI_VERSION === '1.1') return <AuthLayoutV11 />
  return <AuthLayoutV12 />
}
